import * as React from 'react';

function SvgPhoneLandscapeFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M2 12.5a2 2 0 01-2-2v-6a2 2 0 012-2h12a2 2 0 012 2v6a2 2 0 01-2 2H2zm11-6a1 1 0 100 2 1 1 0 000-2z' />
		</svg>
	);
}

export default SvgPhoneLandscapeFill;
